import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { setReduxChannel } from "../../redux/store/channel/channelDuck";

export default function ShareLink(props) {
	const dispatch = useDispatch();
	const history = useHistory();
	const setChannel = (value) => dispatch(setReduxChannel(value));
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	useEffect(() => {
		// eslint-disable-next-line react/prop-types
		let id = props.match.params.id;
		if (id) {
			setChannel({});
			history.replace(`/together/channel?id=${id}`);
		} else {
			setChannel({});
			history.replace("/404");
		}
	}, [props, reduxChannel]);

	return <></>;
}
